import { createAction } from "redux-actions";
import { constants } from "./constants";

export const toggleModal = createAction(constants.toggleModal);

export const sendFeedbackRequest = createAction(constants.sendFeedbackRequest);
export const sendFeedbackSuccess = createAction(constants.sendFeedbackSuccess);
export const sendFeedbackFailure = createAction(constants.sendFeedbackFailure);
